import { React, useState, useEffect } from 'react';


import { getAllImages } from '../../util/api';
import { addImageToSample } from '../../util/api';

import useToken from '../../util/useToken';

import './AddImage.css'

export default function AddImage ({ sampleID, open, setOpen, setRefresh }) {
    const { token, setToken, removeToken, validToken} = useToken();
    const [ images, setImages ] = useState({"results":[]})
    const [ selectedId, setSelectedId ] = useState(null);

    //Pagination variables
    const [ page, setPage ] = useState(1) 
    const [ editedPage, setEditedPage] = useState(1);
    const [ pageSize, setPageSize ] = useState(10)
    const [ resultCount, setResultCount ] = useState(0);


    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => document.body.style.overflow = 'unset';
     }, []);
    

    useEffect(() => {
        const handleImages = async () => {
            let info = await getAllImages(token, page, pageSize)
            setImages(info)
            setResultCount(parseInt(info["resultCount"]))

        }
        handleImages()
    }, [page])


    const handleCheckboxChange = (event, id) => {
        if(id === selectedId){
            setSelectedId(null)
        }else{
            setSelectedId(id)
        }
    };

    const handleFowardClick = () => {
        if(page < (resultCount / pageSize)){
            setPage(page + 1)
        }
    }

    const handleBackClick = () => {
        if(page > 1 ){
            setPage(page - 1)
        }
    }

    const handleSelect = () => {
        addImageToSample(token, sampleID, selectedId).then(response => {
            if(response.status === 200){
                setOpen(false)
                setRefresh(true)
            }else{
                response.json().then(json => {
                    alert(json["message"]);
                })
            }
        })
    }


    return (
            <div className="image-popup">
                <div className="image-popup-content">
                    <h2>Images</h2>
                    <div>
                        <div className="image-table-buttons">
                            <div>
                                <button disabled={selectedId == null} onClick={() => {handleSelect();}}>Select</button>
                            </div>
                            <div>
                                <button onClick={() => {handleBackClick()}}>{"<"}</button>
                                <input
                                    className="page-input"
                                    type="number"
                                    value={editedPage}
                                    onChange={(event) => {setEditedPage(event.target.valueAsNumber || editedPage)}}
                                    onBlur={(event) => {
                                        const enteredPage = event.target.valueAsNumber || editedPage;
                                        const maxPage = Math.ceil(resultCount / pageSize);
                                        setPage(Math.max(1, Math.min(enteredPage, maxPage)));
                                        setEditedPage(Math.max(1, Math.min(enteredPage, maxPage)));
                                    }}
                                />
                                <button onClick={() => {handleFowardClick()}}>{">"}</button>
                            </div>
                        </div>
                        <table className="imagepair-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Image Type</th>
                                    <th>Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {images?.results?.map((result) => (
                                    <tr key={result.id}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedId === result.id}
                                                onChange={event => handleCheckboxChange(event, result.id)}
                                            />
                                        </td>
                                        <td>{result.imageType?.value}</td>
                                        <td>{result.imageLink}</td>
                                    </tr>
                                ))}
                                {images?.results.length == 0 &&
                                    <tr>
                                        <td colSpan="6" style={{ textAlign: 'center' }}>
                                            <p>No Results</p>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <button onClick={() => {setOpen(false)}}>Close</button>
                    {resultCount !== 0 ? <p>{page}/{Math.ceil(resultCount/pageSize)}</p> : <p></p>}
                </div>
            </div>
    );
};

